import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "commodities",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Commodities...",
      sortBy: "name",
      filter: "",
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    commodities: function() {
      return this.$store.getters.commoditiesForTable;
    },
  },
  created() {
    const jsConn = new JSConn();
    this.$store.dispatch("needCommodities", jsConn).then(() => {
      this.dataLoaded = true;
    });
  },
};
